/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-require-imports */
import React, {FC} from 'react';
import Dropzone from 'react-dropzone';
import {
  Image,
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import {getBase64} from '../../../../common/utils/functions';
import {buttonsStyles} from '../../Button/boutonStyle';
import {formsStyles} from '../formStyles';
import styles from '../styles';
import localStyle from './styles';
import {TitleLabel} from './TitleLabel';

interface Props {
  label?: string;
  required?: boolean;
  value?: any;
  onChange?: any;
  name?: any;
  error?: any;
  showError?: boolean;
  isEditable?: boolean;
  type?: any;
  maxLength?: any;
  isFile?: boolean;
  style?: StyleProp<ViewStyle>;
  isBase64?: boolean;
}
export const InputImage: FC<Props> = ({
  label = '',
  name = '',
  required = false,
  showError = false,
  value = '',
  error = '',
  maxLength = 20,
  isEditable = true,
  onChange,
  isFile,
  style,
  isBase64 = false,
}) => {
  const remove = (name: string, value: string) => {
    if (isEditable) {
      onChange(name, value, true, true);
    }
  };

  const handleDrop = (acceptedFiles: any) => {
    if (isEditable) {
      if (acceptedFiles.length === 0) {
        onChange(name, 'INVALID INPUT', true);
      } else {
        if (value.length < maxLength) {
          if (isBase64) {
            getBase64(acceptedFiles[0], base64Data => {
              onChange(
                name,
                {
                  file: acceptedFiles[0],
                  base64: base64Data.substring(base64Data.indexOf(',') + 1),
                },
                true,
              );
            });
          } else {
            onChange(name, acceptedFiles[0], true);
          }
        }
      }
    }
  };

  const renameTitle = (text: string) => {
    return text ? `${text.substring(0, 4)}..` : '';
  };

  const print =
    value && value.length > 0
      ? value.map((elt: any, idx: number) => {
          return (
            <View
              key={`ImageEltInput_${idx}`}
              style={{
                flexDirection: 'row',
                backgroundColor: 'rgba(240, 244, 248, 0.87)',
                padding: 10,
                marginVertical: 5,
                borderRadius: 30,
                marginRight: 10,
              }}>
              <Text>{renameTitle(elt.name)}</Text>
              <TouchableOpacity
                style={{
                  borderWidth: 1,
                  borderColor: '#aaa',
                  backgroundColor: 'rgba(240, 244, 248, 0.87)',
                  height: 30,
                  width: 30,
                  borderRadius: 15,
                  position: 'relative',
                  alignItems: 'center',
                  justifyContent: 'center',
                  top: -17,
                  right: -17,
                }}
                onPress={() => {
                  const v = value.filter((v: any, i: any) => i !== idx);
                  remove(name, v);
                }}>
                <Image
                  source={require('../../../../ressources/images/remove.png')}
                  style={{width: 30, height: 30}}
                />
              </TouchableOpacity>
            </View>
          );
        })
      : null;
  return (
    <View style={[styles.container, style]}>
      <TitleLabel label={label} required={required} />
      <View
        style={[
          localStyle.itemInputStyle,
          {justifyContent: 'space-between'},
          required && showError && error !== '' ? formsStyles.inputError : {},
          {
            backgroundColor: isEditable
              ? '#ffffff'
              : 'rgba(240, 244, 248, 0.87)',
          },
        ]}>
        <View
          style={{
            flexDirection: 'row',
          }}>
          {print}
        </View>
        <View
          style={{
            right: 5,
            top: -12,
            position: 'absolute',
          }}>
          <View
            style={{
              width: 70,
              height: 40,
              flex: 1,
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              paddingVertical: 5,
            }}>
            {value.length < maxLength ? (
              <TouchableOpacity>
                <Dropzone
                  onDrop={handleDrop}
                  accept={
                    isFile
                      ? {
                          'image/png': ['.png'],
                          'image/jpeg': ['.jpeg', '.jpg'],
                          'image/svg+xml': ['.svg'],
                          'application/pdf': ['.pdf'],
                        }
                      : {
                          'image/png': ['.png'],
                          'image/jpeg': ['.jpeg', '.jpg'],
                          'image/svg+xml': ['.svg'],
                        }
                  }>
                  {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({className: ''})}>
                      <input {...getInputProps()} />
                      <View style={buttonsStyles.ButtonGreenNoLabel}>
                        <Image
                          source={require('../../../../ressources/images/attachement.png')}
                          style={buttonsStyles.ButtonGreenImg}
                        />
                      </View>
                    </div>
                  )}
                </Dropzone>
              </TouchableOpacity>
            ) : null}
            {value.length >= maxLength ? (
              <TouchableOpacity disabled={true}>
                <View>
                  <div>
                    <View style={buttonsStyles.ButtonGreenNoLabel}>
                      <Image
                        source={require('../../../../ressources/images/attachement.png')}
                        style={buttonsStyles.ButtonGreenImg}
                      />
                    </View>
                  </div>
                </View>
              </TouchableOpacity>
            ) : null}
          </View>
        </View>
      </View>
      <Text style={styles.textError}>
        {required && showError && error !== '' ? error : ''}
      </Text>
    </View>
  );
};
